module.exports = __webpack_public_path__ + "static/media/Vault Duplicate Search (INV add-in) New Features.fbdd14db.png";